import clsxm from "@/lib/clsxm";
import {type Draft} from "immer";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
import {NumericFormat} from "react-number-format";

const InfluencerFeeConfig: FC<{
  disabled?: boolean;
  influencerFees: {regular?: number | null; pro?: number | null};
  inputFieldClassName?: string;
  labelClassName?: string;
  setInfluencerFees?: (updater: (draft: Draft<{regular?: number | null; pro?: number | null}>) => void) => void;
}> = ({disabled, influencerFees, inputFieldClassName, labelClassName, setInfluencerFees}) => {
  const {t} = useTranslation("payments");

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <span className={clsxm("text-neutral-black flex min-h-5 gap-2 text-xs", labelClassName)}>
          {t("influencer_fees")}
        </span>
        <NumericFormat
          allowNegative={false}
          className={clsxm(
            "disabled:bg-neutral-grey-lightest border-neutral-grey-light text-neutral-black placeholder:text-neutral-grey-light focus:border-primary-medium-solid h-10 w-full rounded-md border bg-white pr-10 pl-4 outline-hidden transition-all duration-150",
            inputFieldClassName,
          )}
          disabled={disabled}
          value={influencerFees.regular}
          onValueChange={value =>
            setInfluencerFees?.(draft => {
              draft.regular = value.floatValue ?? 0;
            })
          }
          suffix="%"
        />
        <span className="text-neutral-grey-dark text-xs leading-3">{t("influencer_fee_description")}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className={clsxm("text-neutral-black flex min-h-5 gap-2 text-xs", labelClassName)}>
          {t("pro_influencer_fees")}
        </span>
        <NumericFormat
          allowNegative={false}
          className={clsxm(
            "border-neutral-grey-light text-neutral-black disabled:bg-neutral-grey-lightest placeholder:text-neutral-grey-light focus:border-primary-medium-solid h-10 w-full rounded-md border bg-white pr-10 pl-4 outline-hidden transition-all duration-150",
            inputFieldClassName,
          )}
          disabled={disabled}
          value={influencerFees.pro}
          onValueChange={value =>
            setInfluencerFees?.(draft => {
              draft.pro = value.floatValue ?? 0;
            })
          }
          suffix="%"
        />
        <span className="text-neutral-grey-dark text-xs leading-3">{t("influencer_fee_description")}</span>
      </div>
    </div>
  );
};

export default InfluencerFeeConfig;
